/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../../../theme';

/* Open - close button  */
export const BasketButtonStyled = styled.div.attrs({
    'className': 'basket-button',
    'data-basket-button': 'basket-button',
})`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 18px;
    background: ${colors.basketButtonBg};
    cursor: pointer;
    &:hover {
        background: ${colors.basketButtonBgHover};
    }
    ${fonts.textSmall};
    color: ${colors.basketButtonText};
`;

/* Main container */
export const BasketContainerStyled = styled.div.attrs({
    'className': 'basket',
    'data-footer-basket': 'basket',
})`
    width: 800px;
    box-sizing: border-box;
    padding: 24px 0;
    & .basket__title, & .basket__search, & .basket__footer {
        padding: 0 24px;
        box-sizing: border-box;
    }
`;

/* TITLE BLOCK */
export const BasketTitleStyled = styled.div.attrs({
    className: 'basket__title',
})`
    display: flex;
    margin-bottom: 24px;
`;

export const BasketTitleCounterStyled = styled.div.attrs({
    'className': 'basket__title-counter',
    'data-basket-counter': 'basket-counter',
})`
    display: flex;
    align-items: center;
    height: 32px;
    margin-left: 8px;
    padding: 0 10px;
    border-radius: 15.5px;
    background: ${colors.basketModuleBg};
`;

export const BasketTitleTextStyled = styled.span`
    ${fonts.textHeader3};
    margin-bottom: 0;
`;

/* CHECKED ALL */
export const BasketCheckedAllTextStyled = styled.span`
    ${fonts.textMain};
`;

export const BasketCheckedAllContainer = styled.div.attrs({
    'className': 'basket__checked-all',
    'data-basket-item': 'basket-checked-all',
})`
    display: flex;
    align-items: center;
    height: 44px;
    padding: 10px 34px;
    box-sizing: border-box;
`;

/* FOOTER BLOCK */
export const BasketFooterStyled = styled.div.attrs({
    'className': 'basket__footer',
    'data-basket-footer': 'basket-footer',
})`
    display: flex;
    align-items: center;
    margin-top: 24px;
    & .basket__footer-link {
        margin-left: 16px;
    }
`;
